module.exports = "/packs/media/images/television-8a6f05dae30d3352c2297e05b8f4a932.jpg";